import axios from 'axios';
import config from 'config';
import { getAiAuthorizationClaims } from './aiChatAuthHelpers';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: { aiWorkspace  : { upload } },
  },
} = config;

export const uploadCsvToAiWorkspace = (csvText, workspaceId, onUploadProgress) => {
  if (!workspaceId) {
    const error = new Error('Workspace ID is required');
    error.code = 'WORKSPACE_ID_REQUIRED';
    throw error;
  }

  const uploadUrl = upload.replace('{workspaceId}', workspaceId);
  return axios.post(
    `${devUrl}${uploadUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      name: 'jobs_csv',
      text: csvText,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
      onUploadProgress,
    },
  );
};
